import { render } from "./SaleReceipt.vue?vue&type=template&id=6c5c7772&scoped=true&ts=true"
import script from "./SaleReceipt.vue?vue&type=script&lang=ts"
export * from "./SaleReceipt.vue?vue&type=script&lang=ts"

import "./SaleReceipt.vue?vue&type=style&index=0&id=6c5c7772&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5c7772"]])

export default __exports__